module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form-wizard', {
    ref: "wizard",
    attrs: {
      "shape": "tab",
      "back-button-text": "Go back!",
      "next-button-text": "Continue",
      "finish-button-text": "Submit Application",
      "color": "#eff9ff"
    },
    on: {
      "on-complete": _vm.onComplete,
      "on-change": _vm.scrollToTop
    }
  }, [_c('div', {
    staticClass: "amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("AR Factoring Application")]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "icon": "far fa-factoring",
      "before-change": _vm.validateFirstTab
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Tell us about your business.")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "firstTabForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.firstTabSchema,
      "options": _vm.formOptions
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "icon": "far fa-sun",
      "before-change": _vm.validateSecondTab
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Next, let's learn a bit more about principals.")]), _vm._v(" "), _c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Business Owner")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "secondTabForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.secondTabSchema,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "col-lg-8"
  }), _vm._v(" "), _c('input', {
    staticClass: "address-check-box",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "address-check-label",
    class: {
      checked: _vm.toggle
    },
    on: {
      "click": function($event) {
        _vm.toggle = !_vm.toggle
      }
    }
  }, [_vm._v("Use business address as my mailing address")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.toggle),
      expression: "!toggle"
    }]
  }, [_c('br'), _vm._v(" "), _c('vue-form-generator', {
    ref: "mailingAddressForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.mailingAddressSchema,
      "options": _vm.formOptions
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "col-lg-8"
  }), _vm._v(" "), _c('div', {
    style: (("display: " + (!_vm.showOwner2 ? 'none' : 'block')))
  }, [_c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Additional Business Owner"), _c('a', {
    staticClass: "delete-add-owner",
    on: {
      "click": function($event) {
        return _vm.deleteOwner2()
      }
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('vue-form-generator', {
    ref: "addOwnerForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.addOwnerSchema,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "col-lg-8"
  }), _vm._v(" "), _c('input', {
    staticClass: "address-check-box",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "address-check-label",
    class: {
      checked: _vm.owner2Toggle
    },
    on: {
      "click": function($event) {
        _vm.owner2Toggle = !_vm.owner2Toggle
      }
    }
  }, [_vm._v("Use business address as my mailing address")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.owner2Toggle),
      expression: "!owner2Toggle"
    }]
  }, [_c('br'), _vm._v(" "), _c('vue-form-generator', {
    ref: "mailingAddress2Form",
    attrs: {
      "model": _vm.model,
      "schema": _vm.mailingAddress2Schema,
      "options": _vm.formOptions
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "col-lg-8"
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "amcredit-add-owner",
    style: (("display: " + (_vm.showOwner2 ? 'none' : 'block'))),
    on: {
      "click": function($event) {
        return _vm.addOwner2()
      }
    }
  }, [_vm._v("Add Owner")])], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "icon": "far fa-consent",
      "before-change": _vm.validateConsentTab
    }
  }, [_c('h3', {
    staticClass: "title consent-title"
  }, [_vm._v("Almost there. Let's review these required consent agreements.")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("Please review and agree to the required consents below. When you are ready, submit your application for review.")]), _vm._v(" "), _c('div', {
    staticClass: "consent-item-wrapper col-lg-8 remove-padding"
  }, [_c('div', {
    staticClass: "flex-container consent-item align-middle",
    attrs: {
      "data-open": "credit-report-modal",
      "aria-controls": "credit-report-modal",
      "aria-haspopup": "true",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.displayCreditReport = true
      }
    }
  }, [_c('div', {
    staticClass: "media-wrap"
  }, [_c('svg', {
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "24",
      "cy": "24",
      "r": "24",
      "fill": "#F0F4F0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 16L31 16V33H17V16Z",
      "fill": "white",
      "stroke": "#053a7a",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 24.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 21.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 27.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container align-justify full-width"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("\n            Consent for American Credit to Obtain a Credit Report\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container consent-item align-middle",
    attrs: {
      "data-open": "contact-modal",
      "aria-controls": "contact-modal",
      "aria-haspopup": "true",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.displayContactYou = true
      }
    }
  }, [_c('div', {
    staticClass: "media-wrap"
  }, [_c('svg', {
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "24",
      "cy": "24",
      "r": "24",
      "fill": "#F0F4F0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 16L31 16V33H17V16Z",
      "fill": "white",
      "stroke": "#053a7a",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 24.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 21.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5 27.5H27.5",
      "stroke": "#053a7a",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-container align-justify full-width"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("\n            Consent for American Credit to Contact You\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "agree-box col-lg-8"
  }, [_c('div', {
    staticClass: "row align-justify align-middle"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "consent-check-box",
    attrs: {
      "type": "checkbox",
      "id": "agree",
      "name": "agree"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "consent-check-label",
    class: {
      checked: _vm.consentToggle
    },
    attrs: {
      "for": "agree"
    },
    on: {
      "click": function($event) {
        _vm.consentToggle = !_vm.consentToggle
      }
    }
  }, [_vm._v("I agree and acknowledge these consents for American Credit and its Assignees to obtain my credit report and contact me.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 consent-sign",
    style: (("display: " + (_vm.consentToggle ? 'block' : 'none')))
  }, [_c('div', [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.model.firstName) + " " + _vm._s(_vm.model.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.currentDate))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "important-notice col-lg-8 remove-padding"
  }, [_c('p', [_vm._v("IMPORTANT INFORMATION ABOUT PROCEDURES FOR BECOMING AN AMERICAN CREDIT CUSTOMER"), _c('br'), _vm._v("\n          To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who receives funding from us."), _c('br'), _vm._v("\n          What this means for you: When you request financing from us, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.")]), _vm._v(" "), _c('p', [_vm._v("NOTICE: The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract) because all or part of the applicant's income derives from any public assistance program, or because the applicant has, in good faith, exercised any right under the Consumer Credit Protection Act. The federal agency that administers our compliance with this law is the Federal Trade Commission, Equal Credit Opportunity, Washington, DC 20580")])])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "icon": "far fa-rev"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Final step! Review your application's information before you submit.")]), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-8 row"
  }, [_c('div', {
    staticClass: "col-lg-6 remove-padding"
  }, [_c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Business Information")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }, [_c('button', {
    staticClass: "edit-review uppercase",
    on: {
      "click": function($event) {
        return _vm.editBusiness()
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('h6', {
    staticClass: "col-lg-6 sub-title remove-padding"
  }, [_vm._v("Company")]), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Business Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.address)), _c('br'), _vm._v(_vm._s(this.model.address2)), _c('br'), _vm._v(_vm._s(this.model.city) + "," + _vm._s(this.model.state) + " " + _vm._s(this.model.zip))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Company Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Company Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyFax))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.taxClassification))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("State of Incorporation")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.stateOfIncorporation))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Company Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Company Web Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyWeb))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Type of Business")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.businessType))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Federal ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.FederalID))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Business Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.businessDescription))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Previous business names used within the past five (5) years")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.previousBusinessNames))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Any subsidiaries or affiliates of business?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anySubsidiariesOrAffiliates))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Explain subsidiaries or affiliates of business if any")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.subsidiariesOrAffiliatesExplanation))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Has there been any change of ownership in the past twelve (12) months?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyChangeOfOwnership))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Explain change of ownership if any")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.changeOfOwnershipExplanation))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any Federal or State taxes past due, including but not limited to withholding taxes?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.taxesPastDue))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Has any lien been filed for your taxes past due?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.taxesPastDueLienFiled))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Has any levies filed for your taxes past due?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyTaxesPastDueLeviesFiled))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Lien or levy details(TYPE; QUARTER/YEAR; AMOUNT: $)")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.taxesPastDueFileDetail))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any payment plans in place?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.taxPaymentPlansInPlace))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _c('h6', {
    staticClass: "col-lg-6 sub-title remove-padding sub-title-margin"
  }, [_vm._v("Legal & Financial")]), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Any lawsuits pending?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.lawsuitsPending))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Explain lawsuits pending if any")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.lawsuitsPendingExplanation))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Any judgements?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyJudgements))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Explain judgements if any")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.judgementsExplanation))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any past bankruptcies?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyPastBankruptcies))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("If any past bankruptcies, when?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.pastBankruptciesWhen))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Bank Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.bankName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Account Officer")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.bankAccountOfficerName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Officer Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.bankPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Account No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.bankAccountNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("City & State")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.bankCityAndState))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _c('h6', {
    staticClass: "col-lg-6 sub-title remove-padding sub-title-margin"
  }, [_vm._v("Accounts Receivable Information")]), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Receivable amount open as of today")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.receivableAmounts))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("No. of Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.numberOfAccounts))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Terms of Sale")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.termsOfSale))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Aging Current")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.agingCurrent))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Aging 31-60")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.aging31_60))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Aging 61-90")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.aging61_90))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Aging 91-120")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.aging91_120))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Aging Over 120")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.agingOver120))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Total sales last 30 days")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.totalSales30Days))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Total sales last 12 months")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.totalSales12Months))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Amount you intend to factor on a monthly basis?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.amountIntendToFactorMonthly))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Where are remittances mailed?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.whereRemittancesMailed))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Have receivables been financed or factored before?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.ifReceivablesFactoredBefore))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Are receivables currently being financed or factored?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.ifReceivablesFactoredCurrently))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Amount of credit losses last three (3) years")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.creditLossesLast3Years))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("What is your average monthly billing?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.averageMonthlyBilling))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("What is your average invoice amount?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.averageInvoiceAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("What is your largest invoice amount?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.largestInvoiceAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("What is your smallest invoice amount?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.smallestInvoiceAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Are any of your receivables Progress Billing?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyReceivablesProgressBilling))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have guaranteed sales?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.haveGuaranteedSales))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any active UCC Filings or are your receivables pledged as collateral?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyActiveUCCFilings))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("If yes, with whom?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.activeUCCFilingsWithWhom))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any outstanding business loans?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyOutstandingBusinessLoans))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("If yes, with whom?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.outstandingBusinessLoanWithWhom))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Loan amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.outstandingBusinessLoanAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Term")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.outstandingBusinessLoanTerm))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Do you have any other company assets pledged as collateral (inventory, buildings)?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.anyCompanyAssetsPledgedAsCollateral))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("If yes, with whom?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.companyAssetsPledgedAsCollateralWithWhom))])])]), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-8 row"
  }, [_c('div', {
    staticClass: "col-lg-6 remove-padding sub-title-margin"
  }, [_c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Owner Information")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding sub-title-margin"
  }, [_c('button', {
    staticClass: "edit-review uppercase",
    on: {
      "click": function($event) {
        return _vm.editOwner()
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('h6', {
    staticClass: "col-lg-6 sub-title remove-padding"
  }, [_vm._v("Principal")]), _c('div', {
    staticClass: "col-lg-6 remove-padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.ownerTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Business Ownership")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.ownership) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.firstName) + " " + _vm._s(this.model.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Social Security Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.ssn))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.dateOfBirth))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.personalPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Driver’s License No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.model.driverLicense))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 remove-padding review-item row"
  }, [_c('div', {
    staticClass: "col-lg-6 item-title"
  }, [_vm._v("Business address is mailing address?")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 item-value"
  }, [_vm._v(_vm._s(this.toggle ? 'Yes' : 'No'))])])]), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-8 row"
  }, [_c('div', {
    staticClass: "col-lg-6 remove-padding sub-title-margin"
  }, [_c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Required Documents")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "amcredit-document-list"
  }, [_c('li', [_vm._v("Corporate or Personal Tax Returns (1 Year Only)")]), _vm._v(" "), _c('li', [_vm._v("Copy of the Company’s Operating Insurance Certificate")]), _vm._v(" "), _c('li', [_vm._v("Copy of Each Officer's Driver’s License")]), _vm._v(" "), _c('li', [_vm._v("Copies of Invoices for Funding")]), _vm._v(" "), _c('li', [_vm._v("Current Aging of Accounts Receivable")]), _vm._v(" "), _c('li', [_vm._v("Current Financial Statements")]), _vm._v(" "), _c('li', [_vm._v("Articles of Incorporation or LLC Operating Agreement")]), _vm._v(" "), _c('li', [_vm._v("Customer List")])])]), _vm._v(" "), _c('div', {
    staticClass: "amcredit-text"
  }, [_vm._v("Upload the above required documents, files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.")]), _vm._v(" "), _c('div', {
    staticClass: "amcredit-text"
  }, [_vm._v("Please upload any documents available now. You can always come back to upload additional documents. Underwriting starts only when all the required documents are in place.")]), _vm._v(" "), _c('div', {
    staticClass: "remove-padding col-lg-12"
  }, [_c('multiple-uploads', {
    on: {
      "ready": function (childVal) {
        _vm.uploadedFiles = childVal
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-8 row"
  }, [_c('div', {
    staticClass: "col-lg-6 remove-padding sub-title-margin"
  }, [_c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Notes (optional)")])]), _vm._v(" "), _c('div', {
    staticClass: "remove-padding col-lg-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brokerNote),
      expression: "brokerNote"
    }],
    attrs: {
      "name": "application-notes",
      "id": "application-notes",
      "cols": "30",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.brokerNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brokerNote = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "reveal-overlay",
    style: (("display: " + (_vm.model.displayPromoCode ? 'block' : 'none')))
  }, [_c('div', {
    staticClass: "reveal small",
    staticStyle: {
      "top": "41px",
      "display": "block"
    },
    attrs: {
      "id": "contact-modal",
      "data-reveal": "2ocrej-reveal",
      "role": "dialog",
      "aria-hidden": "false",
      "data-yeti-box": "contact-modal",
      "data-resize": "contact-modal",
      "data-events": "resize",
      "tabindex": "-1"
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.model.displayPromoCode = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z",
      "fill": "#787D78"
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Promotion code applied successfully!")]), _vm._v(" "), _c('div', {
    staticClass: "intro color-gray ls-n-p-1 f-w-400"
  }, [_vm._v("Your promotion code "), _c('strong', [_vm._v(_vm._s(this.model.promoCode))]), _vm._v(" has been applied successfully. Once your loan is successfully funded, you will receive $100 cash rebate.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "data-close": ""
    },
    on: {
      "click": function($event) {
        _vm.model.displayPromoCode = false
      }
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal-overlay",
    style: (("display: " + (_vm.displayContactYou ? 'block' : 'none')))
  }, [_c('div', {
    staticClass: "reveal small",
    staticStyle: {
      "top": "41px",
      "display": "block"
    },
    attrs: {
      "id": "contact-modal",
      "data-reveal": "2ocrej-reveal",
      "role": "dialog",
      "aria-hidden": "false",
      "data-yeti-box": "contact-modal",
      "data-resize": "contact-modal",
      "data-events": "resize",
      "tabindex": "-1"
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayContactYou = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z",
      "fill": "#787D78"
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Consent for American Credit to Contact You")]), _vm._v(" "), _c('div', {
    staticClass: "intro color-gray ls-n-p-1 f-w-400"
  }, [_vm._v("I hereby confirm that by providing American Credit and its assignees, partners, lenders, or funding service (“Assignees”) with an email address or telephone number, including for a wireless device, I have obtained and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalf of each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit and its Assignees, regardless of their purpose, including but not limited to marketing or collection purposes. \n        I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit and its Assignees; and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "data-close": ""
    },
    on: {
      "click": function($event) {
        _vm.displayContactYou = false
      }
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal-overlay",
    style: (("display: " + (_vm.displayCreditReport ? 'block' : 'none')))
  }, [_c('div', {
    staticClass: "reveal small",
    staticStyle: {
      "top": "41px",
      "display": "block"
    },
    attrs: {
      "id": "contact-modal",
      "data-reveal": "2ocrej-reveal",
      "role": "dialog",
      "aria-hidden": "false",
      "data-yeti-box": "contact-modal",
      "data-resize": "contact-modal",
      "data-events": "resize",
      "tabindex": "-1"
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.displayCreditReport = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z",
      "fill": "#787D78"
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Consent for American Credit to Obtain a Credit Report")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "data-close": ""
    },
    on: {
      "click": function($event) {
        _vm.displayCreditReport = false
      }
    }
  }, [_vm._v("OK")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro color-gray ls-n-p-1 f-w-400"
  }, [_vm._v("I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company's request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, its assignees, partners, lenders, or funding service (“Assignees”) to obtain their respective consumer or business credit reports, as well as use this application and all supporting documentation, now and from time to time, in the credit application and review process."), _c('br'), _c('br'), _vm._v("\n      By selecting ‘I agree’, I am authorized to, and hereby permit, American Credit and its Assignees to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit and its Assignees of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d25e40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplyARFactoringForm.vue
// module id = 1994
// module chunks = 5